import React from 'react'

const WeightIcon = props => (
  <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.91449 4.74866L4.19913 9.46403L4.98861 10.2535L9.70397 5.53814L8.91449 4.74866Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M2.00705 8.61429C1.74246 8.87888 1.74246 9.30912 2.00705 9.57371L2.23508 9.80174L4.64869 12.2153L4.87672 12.4434C5.14131 12.708 5.57155 12.708 5.83614 12.4434C6.10073 12.1788 6.10073 11.7485 5.83614 11.484L4.89178 10.5396L3.91084 9.55865L2.96648 8.61429C2.70188 8.34969 2.27165 8.34969 2.00705 8.61429Z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M1.21753 9.99751C0.989505 10.2255 0.989505 10.5955 1.21753 10.8236L1.75747 11.3635L3.0912 12.6972L3.63114 13.2372C3.85917 13.4652 4.22917 13.4652 4.45719 13.2372C4.68522 13.0091 4.68522 12.6391 4.45719 12.4111L2.04358 9.99751C1.81555 9.76948 1.44555 9.76948 1.21753 9.99751Z"
      fill="url(#paint2_linear)"
    />
    <path
      d="M1.75751 12.3788L2.07373 12.6951C2.26734 12.8887 2.5685 12.9188 2.79437 12.779L1.67576 11.6604C1.53594 11.8862 1.5639 12.1852 1.75751 12.3788Z"
      fill="url(#paint3_linear)"
    />
    <path
      d="M8.06473 2.55662C7.80014 2.82121 7.80014 3.25145 8.06473 3.51604L9.0091 4.4604L9.99003 5.44134L10.9344 6.3857C11.199 6.6503 11.6292 6.6503 11.8938 6.3857C12.1584 6.12111 12.1584 5.69087 11.8938 5.42628L11.6658 5.19826L9.25433 2.78679L9.02631 2.55877C8.76171 2.28987 8.33148 2.28987 8.06473 2.55662Z"
      fill="url(#paint4_linear)"
    />
    <path
      d="M9.44794 1.76711C9.21991 1.99513 9.21991 2.36513 9.44794 2.59316L11.8616 5.00677C12.0896 5.2348 12.4596 5.2348 12.6876 5.00677C12.9156 4.77875 12.9156 4.40875 12.6876 4.18072L12.1477 3.64078L10.8139 2.30705L10.274 1.76711C10.046 1.53908 9.67596 1.53909 9.44794 1.76711Z"
      fill="url(#paint5_linear)"
    />
    <path
      d="M11.1129 2.22317L12.2316 3.34178C12.3692 3.11805 12.3413 2.81904 12.1455 2.62328L11.8293 2.30706C11.6357 2.11346 11.3367 2.08549 11.1129 2.22317Z"
      fill="url(#paint6_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="6.55681"
        y1="7.10634"
        x2="7.34629"
        y2="7.89582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="2.00705"
        y1="8.61429"
        x2="5.83614"
        y2="12.4434"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="1.21753"
        y1="9.99751"
        x2="4.45719"
        y2="13.2372"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="1.51658"
        y1="11.8195"
        x2="2.63519"
        y2="12.9382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="8.06474"
        y1="2.55661"
        x2="11.8938"
        y2="6.38569"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="9.44794"
        y1="1.76711"
        x2="12.6876"
        y2="5.00677"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="11.2711"
        y1="2.06506"
        x2="12.3897"
        y2="3.18367"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
    </defs>
  </svg>
)

export default WeightIcon
